<template>
<!-- Inizio header -->
<header class="Header">
    <div class="Container">
        <div class="Box">
            <div class="Logo"><router-link :to="{'name': 'Home'}" title=""><img src="/images/Logo.png" srcset="/images/LogoRetina.png 2x" alt=""/></router-link></div>  
            <Quicksearch></Quicksearch>
            <div class="Toolbar">
                <div class="ActionLink">
                    <router-link :to="{'name': 'UserDetails'}"><img src="/images/UserIcon.png" srcset="/images/UserIconRetina.png 2x" alt=""/><span>{{ this.risorse["Profilo"]}}</span></router-link>
                    <router-link :to="{'name' : 'ShoppingCart'}"><img src="/images/ShopperIcon.png" srcset="/images/ShopperIconRetina.png 2x" alt=""/><i>{{ this.numElementiCarrello}}</i><span>{{ this.risorse["Cart"]}}</span></router-link>
                </div>
                <div class="CountryMenuBox">
                    <div class="CountryMenuOpenButton">                                               
                        <!--<a id="CountrySelect"  style="cursor:pointer;"><img src="/images/WorldIcon.png" srcset="/images/WorldIconRetina.png 2x" alt=""/><i>Language</i><span>EN</span></a>-->
                        <a id="CountrySelect" style="cursor:pointer;"><img src="/images/WorldIcon.png" srcset="/images/WorldIconRetina.png 2x" alt=""/><i>{{ this.risorse["Lingua"]}}</i><span>{{this.CodiceLingua}}</span></a>
                    </div>
                    <div class="CountryMenu">
                        <ul>
                            <li><a href="javascript:void(0);" :class="{SelectedItem : this.selIt}" @click="this.setLang(true,false,false,false,false,false,'IT')">Italiano</a></li>
                            <li><a href="javascript:void(0);" :class="{SelectedItem : this.selEn}" @click="this.setLang(false,true,false,false,false,false,'EN')">English</a></li>
                            <li><a href="javascript:void(0);" :class="{SelectedItem : this.selDe}" @click="this.setLang(false,false,true,false,false,false,'DE')">Deutsch</a></li>
                            <li><a href="javascript:void(0);" :class="{SelectedItem : this.selFr}" @click="this.setLang(false,false,false,true,false,false,'FR')">Francais</a></li>
                            <li><a href="javascript:void(0);" :class="{SelectedItem : this.selEl}" @click="this.setLang(false,false,false,false,true,false,'EL')">Ελληνικά</a></li>
                            <li><a href="javascript:void(0);" :class="{SelectedItem : this.selPl}" @click="this.setLang(false,false,false,false,false,true,'PL')">Polski</a></li>
                        </ul>
                    </div>
                </div>
            </div>   
        </div>
    </div>
    <Menu></Menu>
</header>

<!-- Fine header -->
</template>


<script>
import Quicksearch from '@/components/Quicksearch.vue';
import Menu from '@/components/Menu.vue';
import {risorseMixin} from "@/mixin.js";

export default {
    name: "Header",
    components:{
        Quicksearch,
        Menu
    },
    data(){
        return {
            selIt: false,
            selEn: true,
            selDe: false,
            selFr: false,
            selEl: false,
            selPl: false,

            CodiceLingua: 'EN'
        }
    },
    mixins:[risorseMixin],
    computed:{
        numElementiCarrello: function(){
            return this.$store.getters.getNumeroElementi;
        }
    },    
    mounted: function(){
        $(document).ready(function() {
            $("#CountrySelect").on("click", function(){
            if ($('body').hasClass('countrymenu')) {
                $('body').removeClass('countrymenu')
                }
                else {
                    $('body').addClass('countrymenu')
                }
            });
        });
        var lang = this.$store.getters.getLingua;
        this.CodiceLingua = lang;
        this.selIt = lang === "IT";
		this.selEn = lang === "EN";
        this.selIt = lang === "DE";
		this.selEn = lang === "FR";
        this.selIt = lang === "EL";
		this.selEn = lang === "PL";

        
    },
    methods: {
        setLang(it,en,de,fr,el,pl, codLang){
            this.selIt = it;
            this.selEn = en;
            this.selDe = de;
            this.selFr = fr;
            this.selEl = el;
            this.selPl = pl;
            this.CodiceLingua = codLang;
			this.$store.dispatch({
                type:'SetLangUtente',
                data: codLang
            }).then((data) =>{
                this.$store.dispatch({
                    type: 'getCatalogsFromApi',
                    token: this.$store.getters.getToken,
                    codiceLingua: this.$store.getters.getLingua  
                }).then(
                    (data) => {
                        if(!data) {
                            this.$router.push("/")
                        }
                    }
                );
            })
        }
    }       
}
</script>

<style>
/* provvisorio */
.CountryMenuOpenButton span {
    background-image: none;
}    
</style>